// extracted by mini-css-extract-plugin
module.exports = {"SearchBar":"RecipesPage_SearchBar__3Tm32","SearchIcon":"RecipesPage_SearchIcon__3d0JG"};